<template>
  <div class="verify-email-page-root__content">
    <MdTypography
      tag="h1"
      textalign="start"
      color="spirits--900"
      variant="heading6--bold"
    >
      {{ $t('components.general.verify_email.banner.title') }}
    </MdTypography>
    <MdTypography
      tag="p"
      textalign="start"
      color="spirits--800"
      variant="body2--regular"
    >
      {{ $t('components.general.verify_email.banner.grace_period_expired_label') }}
    </MdTypography>
    <MdButton
      class="verify-email-page-root__cta"
      data-qa-id="verify-email-button"
      @click="openEmailVerificationModal"
    >
      <MdTypography
        tag="p"
        textalign="start"
        color="taco-yellow--800"
        variant="body2--medium"
      >
        {{ $t('components.general.verify_email.banner.button_label') }}
      </MdTypography>
    </MdButton>
  </div>
</template>
  
<script src="./script.js"></script>
<style lang="scss" src="./stylesheet/index.scss" />
